import { LinkProps, Link } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';

export type NavLinkProps = Pick<LinkProps, 'to' | 'search' | 'params'> & {
  label: string;
  exact?: boolean;
  icon?: LucideIcon;
};

export const NavLink = ({
  to,
  label,
  search,
  params,
  exact,
  icon,
}: NavLinkProps) => {
  const Icon = icon;
  const baseClassName =
    'relative inline-flex w-full items-center justify-start gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200 text-start';

  return (
    <Link
      to={to}
      search={search}
      params={params}
      activeOptions={exact ? { exact: true, includeSearch: false } : undefined}
      className={`${baseClassName} text-white/80 font-semibold hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white`}
      activeProps={{
        className: `${baseClassName} bg-white/20 text-white`,
      }}
    >
      {Icon ? <Icon aria-hidden className="h-4 w-4 shrink-0" /> : null}
      <span className="truncate">{label}</span>
    </Link>
  );
};
